export default () => ({

    open: false,
    get itemsInCart() {
        return this.$store.cart.data.length
    },
    getCount() {
        if (this.itemsInCart == 0) {
            return 'Nothing in cart';
        } else if (this.itemsInCart == 1) {
            return '1 item in cart';
        } else {
            return this.itemsInCart + ' items in cart';
        }
    },
    get shouldShow() {
        return this.itemsInCart !== 0
    },
    get getTotal() {
        let total = 0
        for (const val of this.$store.cart.data) {
            total += val.price.net
        }
        return `Subtotal (excluding tax): $${total}`;
    },
    calculateUndiscountedPrice(price) {
        const undiscountedPrice = price / this.$store.cart.constants.italicDiscount
        const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
            currency: 'USD',
        });
        console.log(this.$store.cart.constants.italicDiscount);
        return formatter.format(undiscountedPrice)
    },
    async remove(item) {
        const response = await fetch('/cart', {method: 'DELETE', body: JSON.stringify({item})})
        const data = await response.json()
        this.$store.cart.replace(data.cart)
    }
})